<ng-container>
    <!-- grid start -->
    <table tsl-table [dataSource]="datasource">
        <!-- Category Column -->
        <ng-container tslColumnDef="category">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@ae8f4fa63ec2efddb388e4dd3e9af121592dbef5"
                t="ae8f4fa63ec2efddb388e4dd3e9af121592dbef5"
                >Category/Subcategory</th
            >
            <td tsl-cell *tslCellDef="let row"
                >{{ translate.get(row.category) }}/{{ translate.get(row.subCategory) }}
            </td>
        </ng-container>

        <!-- Select Column -->
        <ng-container tslColumnDef="select">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                t="9ca82952a6bc860b5391d5975322d8af8ceddfa4"
                >Select</th
            >
            <td tsl-cell *tslCellDef="let row">
                <tsl-checkbox (click)="$event.stopPropagation()" (change)="isSelected($event.checked, row)">
                </tsl-checkbox>
            </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container tslColumnDef="type">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@Type" t="Type">Type</th>
            <td tsl-cell *tslCellDef="let row">{{ translate.get(row.type) }}</td>
        </ng-container>

        <!-- EventType Column -->
        <ng-container tslColumnDef="eventType">
            <th
                tsl-header-cell
                *tslHeaderCellDef
                i18n="@@cd550b7d464c8e32e729980af58ea8e466faeb21"
                t="cd550b7d464c8e32e729980af58ea8e466faeb21"
                >Event Type</th
            >
            <td tsl-cell *tslCellDef="let row">{{ translate.get(row.eventType) }} </td>
        </ng-container>

        <!-- Description Column -->
        <ng-container tslColumnDef="description">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@Description" t="Description">Description</th>
            <td tsl-cell *tslCellDef="let row">{{ translate.get(row.name) }} </td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>

        <!-- Group header -->
        <!-- <ng-container tslColumnDef="groupHeader">
            <td colspan="5" tsl-cell *tslCellDef="let group">
                <strong>{{ group.name }}</strong>
            </td>
        </ng-container>
        <tr tsl-row *tslRowDef="let row; columns: ['groupHeader']; when: isHeader"> </tr> -->
    </table>

    <!-- grid pagination -->
    <tsl-pagination
        showFirstLastButtons
        [pageSizeOptions]="pageSizeOptions"
        [total]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (pageChange)="onPageChange($event)"
        [itemsPerPageLabel]="translate.get('ItemsPerPage')"
    >
    </tsl-pagination>

    <!-- action buttons -->
    <div class="right" *ngIf="pendingDefaultsList && pendingDefaultsList.length > 0">
        <button
            tsl-button
            size="small"
            color="blue"
            (click)="ApproveDefaults()"
            i18n="@@73a83c0db2dbf61230eba62e1d22a6da3d190c4c"
            t="73a83c0db2dbf61230eba62e1d22a6da3d190c4c"
            >Approve</button
        >
        <button
            tsl-button
            size="small"
            color="black"
            (click)="RejectDefaults()"
            i18n="@@20c3d69c0b67a74df0aa3920485016b2080578f6"
            t="20c3d69c0b67a74df0aa3920485016b2080578f6"
            >Reject</button
        >
    </div>
</ng-container>
